import * as React from "react";
import { observer } from "mobx-react-lite";
import { Checkbox } from "antd";
import { ZUid } from "src/types/zUid";
import { groupChecked } from "src/common/groupChecked";
import { Mc2EntityStore } from "../../Mc2EntityStore";

interface PropsMc2SelectionTitle {
  store: Mc2EntityStore;
}

export const Mc2SelectionTitle: React.FC<PropsMc2SelectionTitle> = observer(
  ({ store }) => {
    const { table, selected } = store;
    const checked = groupChecked(table.rows, ({ id }) => selected.has(id));
    return (
      <Checkbox
        checked={checked === "all"}
        indeterminate={checked === "partial"}
        onChange={() => store.toggleTotalSelection()}
      />
    );
  },
);

interface PropsMc2Selection {
  store: Mc2EntityStore;
  rowId: ZUid;
}

export const Mc2Selection: React.FC<PropsMc2Selection> = observer(
  ({ store, rowId }) => (
    <Checkbox
      checked={store.selected.has(rowId)}
      onChange={(e) => store.select(rowId, e.target.checked)}
    />
  ),
);
